module.exports = __webpack_public_path__ + "assets/piatti_freddi.a75f5b98.svg";